module.exports = __webpack_public_path__ + "static/media/video.1fb2bb8a.svg";